import { Component, Input, OnInit } from '@angular/core';
import { CaseAcquisitionStatus, MyCasesData } from '../../../service/cases.service';

@Component({
  selector: 'app-kanban-graphics',
  templateUrl: './kanban-graphics.component.html',
  styleUrls: ['./kanban-graphics.component.scss'],
})
export class KanbanGraphicsComponent implements OnInit {
  @Input()
  leads!: { column: CaseAcquisitionStatus; leads: MyCasesData[] }[];

  totalLeads!: number;
  clientLeads!: number;
  conversionRate!: number;
  completedLeads!: number;
  successfulLeads!: number;
  successfulConversionRate!: number;

  constructor() {}

  ngOnInit(): void {
    this.calculateLeadsInfo();
  }

  ngOnChanges(): void {
    if (this.leads?.length) {
      this.calculateLeadsInfo();
    }
  }

  private calculateLeadsInfo(): void {
    this.totalLeads = 0;
    this.clientLeads = 0;
    this.completedLeads = 0;
    this.successfulLeads = 0;
    this.conversionRate = 0;
    this.successfulConversionRate = 0;

    this.leads.forEach((item) => {
      const count = item.leads.length;

      this.totalLeads += count;

      if (item.column !== CaseAcquisitionStatus.LEAD) {
        this.clientLeads += count;
      }

      if (item.column === CaseAcquisitionStatus.PROCESS_COMPLETED_SUCCESS) {
        this.successfulLeads += count;
      }

      if (
        [
          CaseAcquisitionStatus.PROCESS_COMPLETED_SUCCESS,
          CaseAcquisitionStatus.PROCESS_COMPLETED_FAILURE,
        ].includes(item.column as CaseAcquisitionStatus)
      ) {
        this.completedLeads += count;
      }
    });

    this.conversionRate = Math.floor((this.clientLeads / this.totalLeads) * 100);

    this.successfulConversionRate = this.completedLeads
      ? Math.floor((this.successfulLeads / this.completedLeads) * 100)
      : 0;
  }
}
